if (!customElements.get('sanora-video-player')) {
  customElements.define('sanora-video-player', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      const button = this.querySelector('button');
      const template = this.querySelector('template');
      if (!button || !template) return;
      this.dataset.ready = 'true';
      button.addEventListener('click', () => {
        const content = template.content.cloneNode(true);
        const iframe = content.querySelector('iframe');
        if (iframe) {
          const url = new URL(iframe.src, window.location.origin);
          const hosts = ['www.youtube.com', 'www.youtube-nocookie.com', 'player.vimeo.com'];
          if (url.protocol !== 'https:' || !hosts.includes(url.hostname)) return;
          url.searchParams.set('autoplay', '1');
          iframe.src = url.href;
        }
        this.replaceChildren(content);
        const player = this.querySelector('iframe, video');
        if (player) player.focus();
        const video = this.querySelector('video');
        if (video) video.play().catch(() => {});
      }, { once: true });
    }
  });
}
